import { Paper, Typography } from "@mui/material";
import { Info } from "@/components/VulnerabilityWatch/Info.tsx";
import SplitBar from "@/components/VulnerabilityWatch/Portal/SplitBar.tsx";
import type { KnownPortalOverview } from "@/types";
import { buildWhoSegments } from "@/utils/portalOverview.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function WhoTheyAreSection({ overview }: { readonly overview: KnownPortalOverview | null }) {
  return (
    <Paper variant="outlined" component="section" aria-label={copy.WHO_THEY_ARE} sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{copy.WHO_THEY_ARE}<Info text={copy.TIP_WHO} /></Typography>
      <SplitBar label={copy.WHO_THEY_ARE} segments={buildWhoSegments(overview)} />
    </Paper>
  );
}
